<template>
    <div>
    <div class="" id="">
        <div class="modal-dialog modal-md modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel01">{{i18n('Users')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body">

                    <div class="form-group form-row">
                        <label class="col-sm-3 col-form-label fs-12 pt-12">{{i18n("Name")}}:</label>
                        <div class="col-sm-9">
                            <input type="text" class="form-control base_input" v-model="form.name" disabled>
                        </div>
                    </div>

                    <div class="form-group form-row">
                        <label class="col-sm-3 col-form-label fs-12 pt-12">{{i18n("Phone number")}}:</label>
                        <div class="col-sm-9">
                            <input type="text" class="form-control base_input" v-model="form.phone" disabled>
                        </div>
                    </div>

                    <div class="form-group form-row">
                        <label class="col-sm-3 col-form-label fs-12 pt-12">Email:</label>
                        <div class="col-sm-9">
                            <input type="text" class="form-control base_input" v-model="form.email" disabled>
                        </div>
                    </div>

                    <div class="form-group form-row">
                        <label class="col-sm-3 col-form-label fs-12 pt-12">{{i18n("Type")}}:</label>
                        <div class="col-sm-9">
                            <input type="text" class="form-control base_input" :value="user_type" disabled>
                        </div>
                    </div>

                    <div class="form-group form-row">
                        <label class="col-sm-3 col-form-label fs-12 pt-12">{{i18n("Old Password")}}:</label>
                        <div class="col-sm-9">
                            <form-input :type="'password'" :form="form" :field="'old_password'" :inputClass="'base_input'"></form-input>
                        </div>
                    </div>

                    <div class="form-group form-row">
                        <label class="col-sm-3 col-form-label fs-12 pt-12">{{i18n("New Password")}}:</label>
                        <div class="col-sm-9">
                            <form-input :type="'password'" :form="form" :field="'password'" :inputClass="'base_input'"></form-input>
                        </div>
                    </div>

                    <div class="form-group form-row">
                        <label class="col-sm-3 col-form-label fs-12 pt-12">{{i18n("Confirmed Password")}}:</label>
                        <div class="col-sm-9">
                            <form-input :type="'password'" :form="form" :field="'confirm_password'" :inputClass="'base_input'"></form-input>
                        </div>
                    </div>


                    <div class="text-right">
                        <button type="submit" class="btn base_btn solid_blue waves-effect waves-light"
                                @click="Update()">{{i18n("Refresh")}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="successModal">
        <div class="modal-dialog modal-md modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">


                    <h3>{{i18n("Your password has been successfully updated")}}</h3>

                    <div class="text-right">
                        <button type="submit" class="btn base_btn solid_blue waves-effect waves-light"
                                @click="takeIt()">OK</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>

</template>

<script>
    import FormInput from '../../components/FormInput';
    import FormService from "../../services/FormService";
    export default {
        components: {
            FormInput,
        },
        data() {
            return {
                form: new FormService({
                    name: null,
                    email: null,
                    old_password: null,
                    password: null,
                    confirm_password: null,
                    type: null,
                    status: null,
                    user_role: null,
                    phone: null,
                }),
                user_type: null,
            }
        },
        created() {
            this.defineUser();
        },
        methods: {
            defineUser() {
                this.$api.get('users.current-user')
                    .then(res => {
                        this.form.setData(res.data.user);
                        this.user_type = res.data.user_type;
                    });
            },
            Update() {
                this.form.put('users.update', this.form.id)
                    .then(res => {
                        if (!res.errors) {
                            this.$store.commit('successNotify');
                        }
                    });
            },
            takeIt(){
                $('#successModal').modal('hide');
                this.$router.push('/');
            }
        }
    }
</script>

<style scoped>

</style>